import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputSelectAddonModule } from '../input-select-addon/input-select-addon.module';
import { EditComissionComponent } from './edit-comission/edit-comission.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { InputFieldModule } from '../input-field/input-field.module';
import { EditAllPassengerComissionComponent } from './edit-all-passenger-comission/edit-all-passenger-comission.component';

@NgModule({
  declarations: [EditComissionComponent, EditAllPassengerComissionComponent],
  imports: [
    CommonModule,
    InputSelectAddonModule,
    FormsModule,
    ReactiveFormsModule,
    InputFieldModule,
    SharedModule,
  ],
  exports: [EditComissionComponent, EditAllPassengerComissionComponent],
})
export class CommissionModule {}
